import { getFunctions, httpsCallable } from 'firebase/functions';

// FOR /WORKSPACE PAGE -- GRABBING FOR NEW WORKSPACE DATA

export const getYoutubeWORKSPACEcaptions = ({
  videoId,
  durationInSeconds,
  thumbnailUrl,
  title,
  fullUrl,
  content_id = null
}) => {
  const functions = getFunctions();
  const importYoutubeVideo = httpsCallable(functions, 'getCaptionsYoutubeVision', { timeout: 600000 });

  // Construct the video object (only essential metadata)
  const videoMetadata = {
    videoId,
    videoDuration: durationInSeconds,
    videoThumbnail: thumbnailUrl,
    videoTitle: title,
    fullUrl,
    contentId: content_id ? `workspace-${content_id}` : undefined,
  };

  // Build request payload
  const requestData = { videoMetadata };

  // Initialize error flags
  let is503Error = false;
  let isUnAuthError = false;
  let isInternalError = false;
  let isNotFoundError = false;

  return new Promise((resolve) => {
    importYoutubeVideo(requestData)
      .then((result) => {
        const { message } = result.data;
        resolve({
          message, // "success", "captions_not_available", or "captions_not_available_in_language"
          is503Error,
          isUnAuthError,
          isInternalError,
          isNotFoundError,
        });
      })
      .catch((error) => {
        const code = error.code;
        let message = 'An unknown error occurred';

        // Set error flags based on error code
        switch (code) {
          case 'functions/permission-denied':
            isUnAuthError = true;
            message = 'Permission denied';
            break;
          case 'functions/unavailable':
            is503Error = true;
            message = 'Service unavailable';
            break;
          case 'functions/internal':
            isInternalError = true;
            message = 'Internal server error';
            break;
          case 'functions/not_found':
            isNotFoundError = true;
            message = 'Function not found';
            break;
          default:
            message = error.message || message;
        }

        resolve({
          message,
          is503Error,
          isUnAuthError,
          isInternalError,
          isNotFoundError,
        });
      });
  });
};
